import { DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '@tdwb/core';

export class AccountsAnalytics {

  static accountsTaggingEvents: DataAnalyticsTaggingEvents = {
    pageBalances:{
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'balances',
        subSection1: 'page',
        subSection2: 'balances',
        customPageName: 'wb_account-details-balances'
      }
    },
    pageAccountHoldings: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'holdings',
        subSection1: 'account',
        subSection2: 'holdings',
        customPageName: 'wb_account-details-holdings'
      }
    },
    pageAccountAsset_Allocations: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'asset-allocations',
        subSection1: 'account',
        subSection2: 'asset-allocations',
        customPageName: 'wb_account-details-asset-allocations'
      }
    },
    pageAccountActivity: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'activity',
        subSection1: 'account',
        subSection2: 'activity',
        customPageName: 'wb_account-details-activity',
        appliedFilter: 'not selected'
      }
    },
    pageAccountPerformanceTime_Weighted: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'time-weighted',
        subSection1: 'performance',
        subSection2: 'time-weighted',
        customPageName: 'wb_account-details-time-weighted'
      }
    },
    pageAccountGain_LossBy_Investment: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'by-investment',
        subSection1: 'gain-loss',
        subSection2: 'by-investment',
        customPageName: 'wb_account-details-by-investment'
      }
    },
    pageAccountProjected_Income: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'projected-income',
        subSection1: 'account',
        subSection2: 'projected-income',
        customPageName: 'wb_account-details-projected-income'
      }
    },
    pageAccountStock_Lending: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'stock-lending',
        subSection1: 'account',
        subSection2: 'stock-lending',
        customPageName: 'wb_account-details-stock-lending'
      }
    }
  };

  static preferencesTaggingEvents: DataAnalyticsTaggingEvents = {
    pagePreferencesCustomize_Site: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'customize-site',
        subSection1: 'preferences',
        subSection2: 'customize-site',
        customPageName: 'wb_account-preferences-customize-site'
      }
    },
    pagePreferencesNotifications: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'notifications',
        subSection1: 'preferences',
        subSection2: 'notifications',
        customPageName: 'wb_account-preferences-notifications'
      }
    },
    pagePreferencesSecurity_Options: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'security-options',
        subSection1: 'preferences',
        subSection2: 'security-options',
        customPageName: 'wb_account-preferences-security-options'
      }
    },
    pagePreferencesTrading_Password: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'trading-password',
        subSection1: 'preferences',
        subSection2: 'trading-password',
        customPageName: 'wb_account-preferences-trading-password'
      }
    },
    pagePreferencesRename_Accounts: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'rename-accounts',
        subSection1: 'preferences',
        subSection2: 'rename-accounts',
        customPageName: 'wb_account-preferences-rename-accounts'
      }
    },
    pagePreferencesAgreements: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'agreements',
        subSection1: 'preferences',
        subSection2: 'agreements',
        customPageName: 'wb_account-preferences-agreements'
      }
    },
    pagePreferencesEmail_Notifications: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'email-notifications',
        subSection1: 'preferences',
        subSection2: 'email-notifications',
        customPageName: 'wb_account-preferences-email-notifications'
      }
    },
    'page.notification': {

    }
  };

  static taggingEvents: DataAnalyticsTaggingEvents = {
    ...this.accountsTaggingEvents,
    ...this.preferencesTaggingEvents
  };

}
